export const PARKINSONS_INFO = "Parkinson's disease is a progressive nervous system disorder that affects movement. It results from a combination of both genetic and enviromental factors, such as exposure to toxins. Common symptoms of the dissease include tremors, stiffness and slowment of movement.";

export const RESOURCES = {"NIH:": "https://www.nia.nih.gov/health/parkinsons-disease"};

// **
export const TEST_INFO = "Using data from patients with Parkisons, the test uses .... to predict Parkinsons."

export const WHY_TEST = "Taking the test can warn you if you have common early symptoms of Parkinsons, allowing you to follow up with your doctor. Whie no specific tests currently exist to diagnose Parkinson's, it's important to start treatment early when possible."
